import React from "react";

const SparkleMark = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M12 2.4l1.35 5.85L19.2 9.6l-5.85 1.35L12 16.8l-1.35-5.85L4.8 9.6l5.85-1.35L12 2.4z"
      fill="currentColor"
    />
    <path
      d="M18.6 14.2l.7 2.55 2.55.7-2.55.7-.7 2.55-.7-2.55-2.55-.7 2.55-.7.7-2.55z"
      fill="currentColor"
    />
  </svg>
);

const Loader = ({ container, compact }) => {
  const mark = (
    <div
      className={compact ? "ai-loader ai-loader--sm" : "ai-loader"}
      aria-hidden="true"
    >
      <span className="ai-loader-ring ai-loader-ring--outer" />
      <span className="ai-loader-ring ai-loader-ring--inner" />
      <span className="ai-loader-orbit">
        <span className="ai-loader-dot" />
      </span>
      <span className="ai-loader-core">
        <SparkleMark />
      </span>
    </div>
  );

  if (compact) {
    return (
      <div className="ai-loader-inline" role="status" aria-label="Loading">
        {mark}
      </div>
    );
  }

  return (
    <div
      className={container ? "container-center-loader" : "screen-center-loader"}
      role="status"
      aria-label="Loading"
    >
      {mark}
    </div>
  );
};

export default Loader;
